<script setup lang="ts">
import {useStore} from '../store';

const store = useStore();
</script>

<template>
  <div class="gallery-track">
    <div class="gallery-prev" @click="store.prevImage()" v-if="store.images.length > 1">
      <svg xmlns="http://www.w3.org/2000/svg" width="35.739" height="35.739" viewBox="0 0 35.739 35.739">
        <path d="M0,0H25.271L0,25.271Z" transform="translate(0 17.869) rotate(-45)" fill="#dbd8d8"/>
      </svg>
    </div>
    <div class="gallery-image-wrapper">
      <transition name="gallery">
        <div
            class="gallery-image"
            :key="store.currentImage"
            :style="{'background-image': `url(${store.currentImage})`}"
        />
      </transition>
    </div>
    <div class="gallery-next" @click="store.prevImage()" v-if="store.images.length > 1">
      <svg xmlns="http://www.w3.org/2000/svg" width="35.739" height="35.739" viewBox="0 0 35.739 35.739">
        <path d="M0,0H25.271L0,25.271Z" transform="translate(35.739 17.869) rotate(135)" fill="#dbd8d8"/>
      </svg>
    </div>
  </div>
</template>
